import React, { useState, useContext, useEffect } from 'react';
import Box from '../../components/single_component/Box';
import AddProject1 from '../../components/Forms/AddProject1';
import AddProject2 from '../../components/Forms/AddProject2';
import AddProject3 from '../../components/Forms/AddProject3';
import ProjectContext from '../../context/ProjectContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Props from '../../types/props';
import { useUnsavedChangesWarning } from '../../hooks/useUnsavedChangesWarning';
import UnsavedChangesModal from '../../components/common_component/UnsavedChangesModal';
import { Backdrop, CircularProgress } from '@mui/material';

function EditProjectStepper({ ...props }: Props) {
  const { groupName } = props.extra;
  const { editProject, getProject, ProjectData } = useContext(ProjectContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [activeStep, setActiveStep] = useState<number>(0);
  const [formState, setFormState] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [isDirty, setIsDirty] = useState(false);

  const { showModal, confirmNavigation, cancelNavigation, allowNavigation } =
    useUnsavedChangesWarning(isDirty);

  const onDirty = () => setIsDirty(true);

  // Returns true on success so onNext knows whether to advance the step.
  const submitForm = async (curentFormState: any): Promise<boolean> => {
    console.error('editFormState', curentFormState);
    setLoading(true);
    try {
      const bodyFormData = new FormData();
      curentFormState?.docFiles &&
        Object.keys(curentFormState?.docFiles)?.forEach((doc: any) => {
          bodyFormData.append(doc, curentFormState?.docFiles[doc]);
        });
      curentFormState?.docFiles && delete curentFormState?.docFiles;
      for (const field of Object.keys(curentFormState)) {
        if (curentFormState[field] !== undefined) {
          bodyFormData.append(field, curentFormState[field]);
        }
      }

      const response = await editProject(
        ProjectData?.projectId ?? '',
        bodyFormData
      );
      console.error('response', response);
      const { success } = response;
      setLoading(false);
      if (success) {
        toast.success(response.message);
        if (activeStep >= 2) {
          setIsDirty(false);
          allowNavigation();
          navigate(-1);
        }
        return true;
      } else {
        toast.error(response.message);
        return false;
      }
    } catch (e) {
      setLoading(false);
      console.error(e);
      return false;
    }
  };

  const onNext = async (values: any) => {
    const curentFormState = { ...formState, ...values };
    console.error('formdatat', curentFormState);
    setFormState(curentFormState);
    const success = await submitForm(curentFormState);
    if (success && activeStep < 2) {
      setActiveStep(step => step + 1);
    }
  };

  const onPrevious = () => {
    if (activeStep == 0) {
      window.history.back();
    } else {
      setActiveStep(step => step - 1);
    }
  };

  useEffect(() => {
    getProject(location?.state?.id ?? '');
  }, []);

  return (
    <Box>
      <Backdrop
        open={loading}
        sx={{ zIndex: theme => theme.zIndex.modal + 1, color: '#fff' }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <Box
        style={{
          display: 'flex',
          justifyContent: 'space-around',
          gap: 2,
          marginTop: 1,
        }}>
        <Box
          style={{
            width: '32%',
            height: '5px',
            borderRadius: 5,
            background: activeStep >= 0 ? '#104960' : '#C2C2C2',
          }}></Box>
        <Box
          style={{
            width: '32%',
            height: '5px',
            borderRadius: 5,
            background: activeStep >= 1 ? '#104960' : '#C2C2C2',
          }}></Box>
        <Box
          style={{
            width: '32%',
            height: '5px',
            borderRadius: 5,
            background: activeStep == 2 ? '#104960' : '#C2C2C2',
          }}></Box>
      </Box>

      <Box>
        <Box style={{ display: activeStep === 0 ? 'block' : 'none' }}>
          <AddProject1
            extra={{
              onNext,
              onPrevious,
              projectData: ProjectData,
              groupName,
              onDirty,
            }}
          />
        </Box>
        <Box style={{ display: activeStep === 1 ? 'block' : 'none' }}>
          <AddProject2
            extra={{ onNext, onPrevious, projectData: ProjectData, onDirty }}
          />
        </Box>
        <Box style={{ display: activeStep === 2 ? 'block' : 'none' }}>
          <AddProject3
            extra={{
              onNext,
              onPrevious,
              btnDisableLoader: loading,
              projectData: ProjectData,
              onDirty,
            }}
          />
        </Box>
      </Box>

      <UnsavedChangesModal
        open={showModal}
        onStay={cancelNavigation}
        onLeave={confirmNavigation}
      />
    </Box>
  );
}

export default EditProjectStepper;
